export default __webpack_public_path__ + "static/media/Chat-Numbers-System-08.a7dbc29f.svg";